import { FC, HTMLAttributes } from 'react';

type DiscordProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const Discord: FC<DiscordProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0161 4.19048C14.8794 3.6586 13.6768 3.28058 12.4402 3.06641C12.286 3.34461 12.1066 3.71988 11.9818 4.01715C10.6682 3.81695 9.33198 3.81695 8.01847 4.01715C7.88073 3.6923 7.72596 3.37495 7.5548 3.06641C6.31712 3.28094 5.11365 3.65985 3.97631 4.19308C1.71343 7.61297 1.09983 10.9479 1.40663 14.2352C2.72757 15.2326 4.2117 15.993 5.79285 16.4825C6.14811 15.9936 6.46234 15.4762 6.73233 14.9355C6.2188 14.7398 5.72372 14.4987 5.25292 14.2153C5.37685 14.1234 5.49819 14.0272 5.61519 13.9284C8.4674 15.2622 11.5658 15.2622 14.3842 13.9284C14.5029 14.0272 14.6242 14.1234 14.7464 14.2153C14.2776 14.4978 13.781 14.7405 13.2644 14.9363C13.534 15.4773 13.8482 15.9947 14.2039 16.4833C15.7863 15.9941 17.2714 15.2331 18.5927 14.2343C18.9524 10.4244 17.9783 7.11983 16.0161 4.19048ZM7.1206 12.2133C6.26432 12.2133 5.56232 11.4142 5.56232 10.4409C5.56232 9.46764 6.24959 8.66684 7.1206 8.66684C7.9916 8.66684 8.6936 9.46591 8.67887 10.4409C8.67974 11.4142 7.9916 12.2133 7.1206 12.2133ZM12.8788 12.2133C12.0225 12.2133 11.3205 11.4142 11.3205 10.4409C11.3205 9.46764 12.0078 8.66684 12.8788 8.66684C13.7498 8.66684 14.4518 9.46591 14.437 10.4409C14.437 11.4142 13.7498 12.2133 12.8788 12.2133Z"
        fill="#565960"
      />
    </svg>
  );
};

export default Discord;
